
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"data-name":"Rectangle 110895","width":"24","height":"24","rx":"6","transform":"translate(18 330)","fill":"#e5e5e5"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h41.145v24H0z"}})])]),_c('g',{attrs:{"data-name":"Mask Group 168","transform":"translate(-18 -330)","clip-path":"url(#a)"}},[_c('g',{attrs:{"data-name":"Group 134898"}},[_c('g',{attrs:{"data-name":"Group 134897"}},[_c('g',{attrs:{"data-name":"Group 134896","clip-path":"url(#b)","transform":"translate(13.43 330)"}},[_c('path',{attrs:{"data-name":"Rectangle 110892","d":"M0 15.998h41.145V24H0z"}}),_c('g',{attrs:{"data-name":"Group 134890"}},[_c('g',{attrs:{"data-name":"Group 134889"}},[_c('g',{attrs:{"data-name":"Group 134888","clip-path":"url(#b)"}},[_c('path',{attrs:{"data-name":"Path 150975","d":"M41.186 24.039H-.038v-8.074h41.224v8.073zM.045 23.965h41.061v-7.919H.045v7.919z"}})])])]),_c('path',{attrs:{"data-name":"Rectangle 110893","fill":"#f6f6f6","d":"M0 8.002h41.145v7.997H0z"}}),_c('g',{attrs:{"data-name":"Group 134893"}},[_c('g',{attrs:{"data-name":"Group 134892"}},[_c('g',{attrs:{"data-name":"Group 134891","clip-path":"url(#b)"}},[_c('path',{attrs:{"data-name":"Path 150976","d":"M41.186 16.042H-.038V7.959h41.224v8.083zM.045 15.965h41.061v-7.92H.045v7.92z","fill":"#fff"}})])])]),_c('path',{attrs:{"data-name":"Rectangle 110894","fill":"#bc0030","d":"M0 0h41.145v8.002H0z"}})])])])])])
          )
        }
      }
    